import { render, staticRenderFns } from "./yhsUpload.vue?vue&type=template&id=cc55a22a&scoped=true&"
import script from "./yhsUpload.vue?vue&type=script&lang=js&"
export * from "./yhsUpload.vue?vue&type=script&lang=js&"
import style0 from "./yhsUpload.vue?vue&type=style&index=0&id=cc55a22a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc55a22a",
  null
  
)

export default component.exports